(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cloud-welcome"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-cloud-landing]').forEach(function(section){
var button=section.querySelector('.cloud-squeeze');
button.addEventListener('click',function(){button.classList.remove('is-squeezed');void button.offsetWidth;button.classList.add('is-squeezed');});
button.addEventListener('animationend',function(e){if(e.animationName==='fidshy-home-squeeze')button.classList.remove('is-squeezed');});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"]) return;
  try {
    
document.querySelectorAll('[data-product-section]').forEach(function(section){
var select=section.querySelector('[name=id]'),image=section.querySelector('#product-image'),price=section.querySelector('#product-price'),stock=section.querySelector('[data-stock]'),button=section.querySelector('[data-add]');
function photo(url,alt){if(image&&url){image.removeAttribute('srcset');image.src=url;if(alt)image.alt=alt;}}
section.querySelectorAll('[data-photo].fidshy-thumb').forEach(function(thumb){thumb.addEventListener('click',function(){photo(thumb.dataset.photo,thumb.dataset.alt)})});
if(select&&select.tagName==='SELECT')select.addEventListener('change',function(){var option=select.options[select.selectedIndex],available=option.dataset.available==='true';price.textContent=option.dataset.price;stock.textContent=available?stock.dataset.yes:stock.dataset.no;button.disabled=!available;button.textContent=available?button.dataset.label:stock.dataset.no;photo(option.dataset.photo);var url=new URL(window.location.href);url.searchParams.set('variant',option.value);window.history.replaceState({},'',url);});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shipping-live"]) return;
  try {
    
(function(){
var bars=document.querySelectorAll('[data-shipping-live]');if(!bars.length)return;
var pending=false;
function refresh(){if(pending||document.hidden)return;pending=true;
fetch((window.Shopify&&window.Shopify.routes?window.Shopify.routes.root:'/')+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'})
.then(function(r){if(!r.ok)throw new Error('Cart unavailable');return r.json();})
.then(function(cart){bars.forEach(function(bar){if(cart.currency!=='USD')return;var threshold=Number(bar.dataset.threshold),remaining=Math.max(0,threshold-cart.total_price),amount=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:'USD'}).format(remaining/100),text=remaining?bar.dataset.remaining.replace('__AMOUNT__',amount):bar.dataset.unlocked;
var message=bar.querySelector('[data-shipping-message]');if(message.textContent.trim()!==text)message.textContent=text;
var progress=bar.querySelector('progress');if(progress)progress.value=Math.min(100,cart.total_price/threshold*100);
});}).catch(function(){}).finally(function(){pending=false;});}
window.addEventListener('pageshow',refresh);window.addEventListener('focus',refresh);
document.addEventListener('visibilitychange',refresh);
['cart:updated','cart:change','cart:refresh'].forEach(function(event){document.addEventListener(event,refresh);});
document.addEventListener('submit',function(e){if(e.target.action&&e.target.action.includes('/cart')){setTimeout(refresh,800);setTimeout(refresh,2500);}});
setInterval(refresh,15000);refresh();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["squish-break"] && !Shopify.designMode) return;
  try {
    
(function(){
document.querySelectorAll('[data-squish-game]').forEach(function(game){
if(game.dataset.ready)return;game.dataset.ready='true';
var button=game.querySelector('.squish-toy'),status=game.querySelector('.squish-status'),reward=game.querySelector('.squish-reward'),dots=game.querySelectorAll('.squish-dots i'),count=0;
function render(){dots.forEach(function(dot,i){dot.classList.toggle('done',i<count)});status.textContent=count>=3?status.dataset.done:status.dataset.progress.replace('__COUNT__',String(count));if(count>=3)reward.hidden=false;}
function release(){button.classList.remove('is-pressed');}
button.addEventListener('pointerdown',function(){button.classList.add('is-pressed')});
button.addEventListener('pointerup',release);button.addEventListener('pointercancel',release);button.addEventListener('pointerleave',release);button.addEventListener('blur',release);
button.addEventListener('keydown',function(e){if(e.key===' '||e.key==='Enter'){if(e.repeat){e.preventDefault();return;}button.classList.add('is-pressed')}});
button.addEventListener('keyup',release);
button.addEventListener('click',function(){release();count=Math.min(3,count+1);render();});
render();
});
})();

  } catch(e) { console.error(e); }
})();
})();
